import React, { useState } from "react";
import { Col, FormGroup, Input, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Btn, H2, P, Image } from "../AbstractElements";
import { dynamicImage } from "../Utils";
import {
  EmailAddress,
  ForgotPassword,
  Password,
  SignIn,
  SignInAccount,
} from "../Utils/Constants";
import axios from "axios";
import { baseUrl } from "../Utils/FileUpload";
import {
  useForm,
  Controller,
  SubmitHandler,
  FieldError,
} from "react-hook-form";

import { useAuth } from "../Context/AuthContext";

type FormData = {
  email: string;
  password: string;
};

export default function SignInForm() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!isPasswordVisible);

  const onSubmit = async (data: FormData) => {
    setLoading(true); // Start loading
    try {
      const response = await axios.post(`${baseUrl}login`, {
        email: data.email,
        password: data.password,
      });

      const token = response.data.token;
      const user = response.data.user;

      toast.success("Login Success!");

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user || {}));
      localStorage.setItem("permissions", JSON.stringify(user?.permissions || []));
      localStorage.setItem("login", JSON.stringify(true));
      setUser(user || null);

      navigate(`/dashboard`);
    } catch (error: any) {
      console.error("Login error:", error);
      const errorMessage = error.response?.data?.message || "Login error";
      toast.error(errorMessage);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <div>
        <Link className="logo" to="#">
          <Image
            className="img-fluid for-light m-auto"
            src={dynamicImage(`logo/logo-dark.png`)}
            alt="loginpage"
          />
          <Image
            className="img-fluid for-dark"
            src={dynamicImage(`logo/logo-dark.png`)}
            alt="loginpage"
          />
        </Link>
      </div>
      <div className="login-main">
        <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
          <H2 className="text-center">{SignInAccount}</H2>
          <P className="text-center">
            {"Enter your email & password to login"}
          </P>

          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{ required: "Please enter your email" }}
              render={({ field }) => (
                <Input
                  type="email"
                  {...field}
                  placeholder="Email"
                  invalid={!!errors.email}
                />
              )}
            />
            {errors.email && (
              <div className="text-danger">
                {(errors.email as FieldError).message}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Col>
              <Label>{Password}</Label>
            </Col>
            <Controller
              name="password"
              control={control}
              defaultValue=""
              rules={{ required: "Please enter your password" }}
              render={({ field }) => (
                <div className="form-input position-relative">
                  <Input
                    type={isPasswordVisible ? "text" : "password"}
                    {...field}
                    placeholder="Password"
                    invalid={!!errors.password}
                  />
                  <div className="show-hide" onClick={togglePasswordVisibility}>
                    <span className={!isPasswordVisible ? "show" : ""}></span>
                  </div>
                </div>
              )}
            />
            {errors.password && (
              <div className="text-danger">
                {(errors.password as FieldError).message}
              </div>
            )}
          </FormGroup>

          <FormGroup className="mb-0 checkbox-checked">
            <Link className="link" to={`/forgot-password`}>
              {ForgotPassword}
            </Link>

            <div className="text-end mt-3">
              <Btn
                color="primary"
                className="w-100"
                block
                type="submit"
                disabled={loading}
              >
                {loading ? "Signing in..." : SignIn}
              </Btn>
            </div>
          </FormGroup>
          <div className="text-center mt-3" style={{ display: "none" }}>
            <a
              href="/privacy_policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-underline"
            >
              Privacy Policy
            </a>
          </div>
          <div className="text-center mt-2" style={{ display: "none" }}>
            <Link to="/delete-account" className="text-decoration-underline text-danger">
              Delete Account
            </Link>
          </div>
          <div className="text-center mt-2" style={{ display: "none" }}>
            <Link to="/delete-account-agent" className="text-decoration-underline text-danger">
              Delete Agent Account
            </Link>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}

// import React, { FormEvent, useState } from "react";
// import { Col, Form, FormGroup, Input, Label } from "reactstrap";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Btn, H2, P, Image } from "../AbstractElements";
// import { dynamicImage } from "../Utils";
// import {
//   EmailAddress,
//   Password,
//   SignIn,
//   SignInAccount,
// } from "../Utils/Constants";
// import axios from "axios";
// import { baseUrl } from "../Utils/FileUpload";

// export default function SignInForm() {
//   const navigate = useNavigate();
//   const [isPasswordVisible, setPasswordVisible] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const toggle = () => setPasswordVisible(!isPasswordVisible);

//   const handleSubmit = async (e: FormEvent) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post(`${baseUrl}login`, {
//         email,
//         password
//       });

//       const token = response.data.token;

//       toast.success("Login Success!");

//       // Save token to localStorage
//       localStorage.setItem("token", token);
//       localStorage.setItem("login", JSON.stringify(true));

//       navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
//     } catch (error: any) {
//       console.error("Login error:", error);
//       toast.error("Login error");
//     }
//   };

//   return (
//     <div>
//       <div>
//         <Link className="logo" to="#">
//           <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo1.png`)} alt="loginpage" />
//           <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo-dark.png`)} alt="loginpage" />
//         </Link>
//       </div>
//       <div className="login-main">
//         <Form className="theme-form" onSubmit={handleSubmit}>
//           <H2 className="text-center">{SignInAccount}</H2>
//           <P className="text-center">{"Enter your email & password to login"}</P>

//           <FormGroup>
//             <Col>
//               <Label>{EmailAddress}</Label>
//             </Col>
//             <Input
//               type="email"
//               value={email}
//               onChange={(event) => setEmail(event.target.value)}
//               required
//             />
//           </FormGroup>

//           <FormGroup>
//             <Col>
//               <Label>{Password}</Label>
//             </Col>
//             <div className="form-input position-relative">
//               <Input
//                 type={isPasswordVisible ? "text" : "password"}
//                 value={password}
//                 onChange={(event) => setPassword(event.target.value)}
//                 required
//               />
//               <div className="show-hide" onClick={toggle}>
//                 <span className={!isPasswordVisible ? "show" : ""}></span>
//               </div>
//             </div>
//           </FormGroup>

//           <FormGroup className="mb-0 checkbox-checked">
//             <div className="text-end mt-3">
//               <Btn color="primary" className="w-100" block>
//                 {SignIn}
//               </Btn>
//             </div>
//           </FormGroup>
//         </Form>
//       </div>
//     </div>
//   );
// }

// import React, { FormEvent, useState } from 'react'
// import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
// import { Link, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { Btn, H2, H6, Image, P } from '../AbstractElements';
// import { dynamicImage } from '../Utils';
// import { CreateAccount, DontHaveAccount, EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from '../Utils/Constants';
// import SocialLink from './SocialLink';

// export default function SignInForm() {
//     const navigate = useNavigate();
//     const [isPasswordVisible, setPasswordVisible] = useState(false);
//     const [email, setEmail] = useState("test123@gmail.com");
//     const [password, setPassword] = useState("Test@123");
//     const toggle = () => setPasswordVisible(!isPasswordVisible);
//     const handleSubmit = (e: FormEvent) => {
//         e.preventDefault()
//         if (email === "test123@gmail.com" && password === "Test@123") {
//             toast.success("Login Success...!");
//             navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
//             localStorage.setItem("login", JSON.stringify(true));
//         } else {
//             toast.error("Please Enter valid email or password...!");
//         }
//     };
//     return (
//         <div>
//             <div>
//                 <Link className='logo' to={`${process.env.PUBLIC_URL}/dashboard/default`}>
//                     <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo1.png`)} alt="looginpage" />
//                     <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo-dark.png`)} alt="looginpage" />
//                 </Link>
//             </div>
//             <div className="login-main">
//                 <Form className="theme-form" onSubmit={handleSubmit}>
//                     <H2 className="text-center">{SignInAccount}</H2>
//                     <P className="text-center">{"Enter your email & password to login"}</P>
//                     <FormGroup>
//                         <Col><Label>{EmailAddress}</Label></Col>
//                         <Input type="email" defaultValue={email} onChange={(event) => setEmail(event.target.value)} />
//                     </FormGroup>
//                     <FormGroup>
//                         <Col><Label>{Password}</Label></Col>
//                         <div className="form-input position-relative">
//                             <Input type={isPasswordVisible ? 'text' : 'password'} defaultValue={password} onChange={(event) => setPassword(event.target.value)} name="login[password]" />
//                             <div className='show-hide' onClick={toggle}>
//                                 <span className={!isPasswordVisible ? 'show' : ''}></span>
//                             </div>
//                         </div>
//                     </FormGroup>
// <FormGroup className="mb-0 checkbox-checked">
//     <FormGroup className="checkbox-solid-info" check>
//         <Input id="checkbox1" type="checkbox" />
//         <Label htmlFor="checkbox1" check>{RememberPassword}</Label>
//     </FormGroup>
//     <Link className="link" to={`${process.env.PUBLIC_URL}/authentication/forget_password`}>{ForgotPassword}</Link>
//     <div className="text-end mt-3">
//         <Btn color='primary' className="w-100" block>{SignIn}</Btn>
//     </div>
// </FormGroup>
//                     <div className="login-social-title"><H6>{SignInWith}</H6></div>
//                     <SocialLink />
//                     <P className="mt-4 mb-0 text-center">{DontHaveAccount}
//                         <Link className="ms-2" to={`${process.env.PUBLIC_URL}/authentication/register_simple`}>{CreateAccount}</Link>
//                     </P>
//                 </Form>
//             </div>
//         </div>
//     )
// }
